import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-button-cell-renderer',
	templateUrl: './button-cell-renderer.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./button-cell-renderer.component.scss'],
	imports: [MatIconButton, MatIcon],
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
	public params: any;

	agInit(params: any): void {
		this.params = params;
	}

	btnClickedHandler(e) {
		this.params.clicked(this.params?.data);
	}

	refresh(params: ICellRendererParams<any>): boolean {
		return false;
	}
}
